import { initContract } from '@ts-rest/core';

import { analogContract } from './analog/analog.contract';
import { apiTokenContract } from './api-token/api-token-contract';
import { authContract } from './auth/auth-contract';
import { configContract } from './config/config-contract';
import { documentAcceptanceContract } from './document-acceptance/document-acceptance-contract';
import { organizationContract } from './organization/organization-contract';
import { parameterPresetContract } from './parameter-preset/parameter-preset-contract';
import { referenceReactionContract } from './reference-reaction/reference-reaction-contract';
import { reportContract } from './report/report-contract';
import { retrosynthesisContract } from './retrosynthesis/retrosynthesis-contract';
import { searchContract } from './search/search-contract';
import { startingMaterialContract } from './starting-materials/starting-materials-contract';
import { userContract } from './user/user-contract';
import { reactionConditionsContract } from './reaction-conditions/reaction-conditions.contract';

const c = initContract();

export const apiContract = c.router({
  analog: analogContract,
  apiToken: apiTokenContract,
  auth: authContract,
  config: configContract,
  documentAcceptance: documentAcceptanceContract,
  user: userContract,
  parameterPreset: parameterPresetContract,
  referenceReactions: referenceReactionContract,
  report: reportContract,
  retrosynthesis: retrosynthesisContract,
  startingMaterials: startingMaterialContract,
  search: searchContract,
  organization: organizationContract,
  reactionConditions: reactionConditionsContract,
});
